import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const CounterAreaOneItem = ({ item }) => {
  const [value, setValue] = useState(0);
  const nodeRef = useRef(null);
  const rafRef = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const node = nodeRef.current;
    if (!node) return;

    const animateTo = (target) => {
      const duration = 1800;
      const startTime = performance.now();
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const tick = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const current = Math.round(target * easeOutCubic(progress));
        setValue(current);
        if (progress < 1) rafRef.current = requestAnimationFrame(tick);
      };

      rafRef.current = requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            animateTo(item.amount);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [item.amount]);

  const cardBody = (
    <div ref={nodeRef} className="counter-item">
      <div className="icon">{item.icon}</div>
      <div className="content">
        <h2 className="count">
          <span>{value}+</span>
        </h2>
        <p>{item.title}</p>
      </div>
    </div>
  );

  if (item.url) {
    return (
      <Link to={item.url} className="counter-item-link" aria-label={item.title}>
        {cardBody}
      </Link>
    );
  }

  return cardBody;
};

export default CounterAreaOneItem;
